import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler } from 'ionic-angular';
import { IonicModule } from 'ionic-angular';
import { LOCALE_ID } from '@angular/core';

// Note(Moris): RxJS � una libreria piuttosto grande, le buone prassi indicano di importare solamente gli operatori indispensabili
import "rxjs/Rx";
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';

import { MyApp } from './app.component';

import { PropertiesPopover } from '../components/popovers/properties.popover';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { AuthHttp } from '../services/auth.http';
import { AuthService } from '../services/auth.service';
import { PropertiesService } from '../services/properties.service';
import { ResidentialService } from '../services/residential.service';
import { ImagesService } from '../services/images.service';

import { ConfigStore } from '../stores/config.store';
import { UserStore } from '../stores/user.store';
import { PropertiesStore } from '../stores/properties.store';
import { ResidentialStore } from '../stores/residential.store';

@NgModule({
    declarations: [
        MyApp,
        PropertiesPopover
    ],
    imports: [
        HttpModule,
        BrowserModule,
        IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/config/config.module#ConfigModule', name: 'ConfigPage', segment: 'settings', priority: 'low', defaultHistory: ['PropertiesPage'] },
    { loadChildren: '../pages/gallery/gallery.module#GalleryModule', name: 'GalleryPage', segment: 'gallery/:id_pratica', priority: 'low', defaultHistory: ['PropertiesPage'] },
    { loadChildren: '../pages/home/home.module#HomeModule', name: 'HomePage', segment: 'info', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#HomeModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/properties/properties.module#HomeModule', name: 'PropertiesPage', segment: 'properties', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/residential/residential.module#HomeModule', name: 'ResidentialPage', segment: 'residential/:Id_Pratica', priority: 'low', defaultHistory: ['PropertiesPage'] },
    { loadChildren: '../pages/whatsapp/whatsapp.module#WhatsAppModule', name: 'WhatsAppPage', segment: 'whatsapp', priority: 'low', defaultHistory: [] }
  ]
})
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        PropertiesPopover
    ],
    providers: [
        StatusBar,
        SplashScreen,
        AuthHttp,
        AuthService,
        PropertiesService,
        ResidentialService,
        ImagesService,
        ConfigStore,
        UserStore,
        PropertiesStore,
        ResidentialStore,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        { provide: LOCALE_ID, useValue: "it-IT" }
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts